<button
  nbButton
  outline
  status="primary"
  size="small"
  (click)="redirect()"
  title="{{ value.title }}">
  {{ value.title }}
</button>
